/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PostContactUsFormInput = {|
  email: string,
  firstName: string,
  issueType: string,
  lastName: string,
  message: string,
  orderNumber?: ?string,
  phoneNumber?: ?string,
  postcode?: ?string,
|};
export type PostContactUsFormMutationVariables = {|
  input: PostContactUsFormInput
|};
export type PostContactUsFormMutationResponse = {|
  +postContactUsForm: ?{|
    +result: ?boolean
  |}
|};
export type PostContactUsFormMutation = {|
  variables: PostContactUsFormMutationVariables,
  response: PostContactUsFormMutationResponse,
|};
*/


/*
mutation PostContactUsFormMutation(
  $input: PostContactUsFormInput!
) {
  postContactUsForm(input: $input) {
    result
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PostContactUsFormPayload",
    "kind": "LinkedField",
    "name": "postContactUsForm",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PostContactUsFormMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PostContactUsFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "37c95eb7f223e633e82a715702a03e21",
    "id": null,
    "metadata": {},
    "name": "PostContactUsFormMutation",
    "operationKind": "mutation",
    "text": "mutation PostContactUsFormMutation(\n  $input: PostContactUsFormInput!\n) {\n  postContactUsForm(input: $input) {\n    result\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1ad8ab6f265602f83cb08ae288b6579c';

module.exports = node;
